module.exports = {
  'en': {
    'STD_REQP1': {
      '10': 'Detail of Personnel Requisition',
      '20': 'P.R. No.',
      '30': 'Details(1)',
      '40': 'For Department',
      '50': 'Requested By',
      '60': 'Approved By',
      '70': 'Recruiter\'s Name',
      '80': 'Recruiter\'s Position',
      '90': 'Date of Request',
      '100': 'Approved Date',
      '110': 'Comments',
      '120': 'Status',
      '130': 'No. of Request',
      '140': 'Pers.',
      '150': 'No. of Filled',
      '160': 'Pers.',
      '170': 'Available',
      '180': 'Pers.',
      '190': 'Other Detail'
    },
    'STD_REQP2': {
      '10': 'Details(2)',
      '20': 'Position Req.',
      '30': 'Job Description',
      '40': 'Type of Employment',
      '50': 'Employment Period',
      '60': 'Yrs.',
      '70': 'Month',
      '80': 'Salary',
      '90': 'Req.Date',
      '100': 'Open Date for app.',
      '110': 'No. of Emp. Req.',
      '120': 'Pers.',
      '130': 'Filled',
      '140': 'Pers.',
      '150': 'Available',
      '160': 'Pers.',
      '170': 'Former Employer',
      '180': 'Recuit From',
      '190': 'Internal',
      '200': 'External',
      '210': 'Close Date',
      '220': 'Qualification Spec.',
      '230': 'Reason of Request',
      '240': 'By Job Spec.',
      '250': 'New Criteria',
      '260': 'Remark'
    },
    'STD_REQP3': {
      '10': 'List of Applicants',
      '20': 'Position',
      '30': 'Applicant No.',
      '40': 'Emp.Code',
      '50': 'Name',
      '60': 'Status',
      '70': 'Last Upd.Date',
      '80': 'List of Applicants'
    }
  },
  'th': {
    'STD_REQP1': {
      '10': 'รายละเอียดใบขออนุมัติ',
      '20': 'เลขที่ใบขออนุมัติ',
      '30': 'รายละเอียด(1)',
      '40': 'สำหรับหน่วยงาน',
      '50': 'รหัสผู้ขออนุมัติ',
      '60': 'รหัสผู้อนุมัติ',
      '70': 'รหัสผู้รับสมัคร',
      '80': 'ตำแหน่งผู้รับสมัคร',
      '90': 'วันที่ขออนุมัติ',
      '100': 'วันที่อนุมัติ',
      '110': 'หมายเหตุ',
      '120': 'สถานะ',
      '130': 'จำนวนที่ขอ',
      '140': 'คน',
      '150': 'จำนวนจัดสรร',
      '160': 'คน',
      '170': 'คงเหลือ',
      '180': 'คน',
      '190': 'รายละเอียดอื่นๆ'
    },
    'STD_REQP2': {
      '10': 'รายละเอียด(2)',
      '20': 'ตำแหน่งที่ขอ',
      '30': 'ลักษณะงาน',
      '40': 'ประเภทการจ้างงาน',
      '50': 'กำหนดการจ้างงาน',
      '60': 'ปี',
      '70': 'เดือน',
      '80': 'เงินเดือน',
      '90': 'วันที่ต้องการ',
      '100': 'วันที่เปิดรับสมัคร',
      '110': 'จำนวนที่ขอ',
      '120': 'คน',
      '130': 'จัดสรร',
      '140': 'คน',
      '150': 'คงเหลือ',
      '160': 'คน',
      '170': 'ชื่อบริษัทเดิม',
      '180': 'ขอจาก',
      '190': 'ภายใน',
      '200': 'ภายนอก',
      '210': 'วันที่ปิดรับสมัคร',
      '220': 'คุณสมบัติที่ต้องการ',
      '230': 'สาเหตุการขอ',
      '240': 'ตามลักษณะงาน',
      '250': 'กำหนดขึ้นใหม่',
      '260': 'หมายเหตุ'
    },
    'STD_REQP3': {
      '10': 'รายชื่อผู้สมัคร',
      '20': 'ตำแหน่ง',
      '30': 'เลขที่ใบสมัคร',
      '40': 'รหัสพนักงาน',
      '50': 'ชื่อ',
      '60': 'สถานะ',
      '70': 'วันที่ล่าสุด',
      '80': 'รายชื่อผู้สมัคร'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/stdreq.js